import React, { useCallback, useEffect, useRef, useMemo } from 'react';
import {
    Typography,
    Grid,
    Button,
    useTheme,
    Slide,
    Box,
} from '@material-ui/core';
import classNames from 'classnames';
import sacolaVazia from 'arquivos-estaticos/global/imagens/sacolaVazia.svg';
import { useStyles } from './sacola-styles';
import { CardapioStorageKeys, useCardapioStorage } from 'storage/cardapio-storage';
import { isEmpty } from 'lodash';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { OkIcon } from 'utils/Icons/ok-icon';
import { EnumOpcoesDelivery, useEsvaziarSacola, useRemoverSacola } from 'storage';
import { isValidUUIDV4 } from 'utils/is-valid-id';
import { EnumFasesSacola } from '../../../cardapio-sacola';
import { usePedidos } from 'services/providers/pedidos-provider';
import { ContatoModel, PessoaModel } from 'api/cardapio/models/pessoa/pessoa-model';
import { guidEmpty } from 'utils/guid-empty';
import { ConfigEmpresaModel } from 'api/cardapio/models/empresa/empresa-model';
import { EnumTpProduto, MovSimplesProdutoModel } from 'api/cardapio/models/produto/mov-simples-produto-model';
import { EnumTipoContato } from 'models/enums/enum-tipo-contato';
import { FasesHeader } from '../components/fases-header/fases-header';
import { CardapioDadosProps } from 'modulos/cardapio/containers/cardapio/cardapio-header/cardapio-header-props';
import { ItemSacolaCard } from './components/item-sacola-card';
import { useMesaStore } from 'services/store/mesa-store';
import { CarrinhoIcon } from 'utils/Icons/carrinho-icon';
import { EnumConfigEmpresa } from 'models/enums/enum-config-empresa';
import { PedidoValores } from '../../pedido-valores/pedido-valores';
import { OpcoesDelivery } from './components/opcoes-delivery';
import { useEmpresaAtual } from 'services/hooks/empresa';
import { usePedidoWhatsapp } from 'services/hooks/pedido-whatsapp';
import { useDadosDeliveryStore } from 'services/store/dados-delivery';
import { usePessoaUsuarioStore } from 'services/store/pessoa-usuario';
import { CircularLoading } from 'components/utils/circular-loading';
import { VoltarIcon } from 'utils';

export interface SacolaProps {
    cardapioDados: CardapioDadosProps | undefined;
    empresaId: string;
    mesaId: string;
    sacolaAberta: boolean;
    quandoFechado: () => any;
    abrirModalCliente: () => void;
    editarItem: (item: MovSimplesProdutoModel) => void;
    faseSacola: EnumFasesSacola;
    handlePedidoFluxo: (nextOrBack: React.MutableRefObject<0 | 1>) => void
    configEmp: ConfigEmpresaModel[];
    pedidoDelivery: boolean
    onClickProximaFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    onClickVoltarFase: (nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => void
    foiAbertoSacola: React.MutableRefObject<boolean>
}

export const Sacola = ({
    cardapioDados,
    empresaId,
    mesaId,
    quandoFechado,
    sacolaAberta,
    editarItem,
    faseSacola,
    handlePedidoFluxo,
    configEmp,
    pedidoDelivery,
    onClickProximaFase,
    onClickVoltarFase,
    foiAbertoSacola
}: SacolaProps) => {

    const classes = useStyles()
    const { getRegistro } = useCardapioStorage()
    const { tipoDelivery, dadosWhatsapp } = useDadosDeliveryStore()
    const { pedidoAtual, getPedido, setCliente, codComanda, addOuAttProdutoEntrega, carregando, getClientePadraoWrapper, carregandoEfetuarNovaVenda, setCodComanda, getItensSacola, getItemEntrega, removerItemEntregaSacola, cliente } = usePedidos()
    const theme = useTheme()
    const [removerSacola] = useRemoverSacola();
    const [esvaziarSacola] = useEsvaziarSacola();
    const { getConfigByCod } = useEmpresaAtual()
    const { fazerPedidoWhatsApp } = usePedidoWhatsapp()
    const nextOrBack = useRef<0 | 1>(1)

    const itemEntrega = useMemo(() => getItemEntrega(), [getItemEntrega])
    const itens = useMemo(() => getItensSacola().filter(item => item.produtoId !== itemEntrega?.produtoId), [getItensSacola, itemEntrega?.produtoId])

    const clienteEstaNaLoja = useCallback((): boolean => {
        //verificar se tem o mesaId e se é válido
        if (!isEmpty(mesaId) && isValidUUIDV4(mesaId))
            return true;

        return false;
    }, [mesaId]);

    const produtoEntrega = useMemo(() => cardapioDados?.configuracoesDelivery.produtoEntrega?.id, [cardapioDados?.configuracoesDelivery.produtoEntrega?.id])

    useEffect(() => {
        if (sacolaAberta && mesaId) {
            if (cardapioDados?.configuracoes.tipoUsoCardapio === 2) {
                getPedido();
            }
        }
    }, [cardapioDados?.configuracoes.tipoUsoCardapio, getPedido, mesaId, sacolaAberta, setCodComanda])

    const calcularCorSacola = useCallback(() => {
        return `grayscale(1) contrast(1.1) opacity(.65) drop-shadow(0 0 0 ${theme.palette.primary.light})`;
    }, [theme.palette.primary.light]);

    useEffect(() => {
        document.body.classList.toggle(classes.scrollPage);
    }, [classes.scrollPage, sacolaAberta]);

    const produtosVendaAdicionais =
        itens?.filter(
            (produto) => produto.pedidoId === ''
        ) ?? [];

    const agruparProdutos = () => {
        const produtosAgrupados: MovSimplesProdutoModel[] = produtosVendaAdicionais.filter(
            (p) =>
                !p.produtoPaiId &&
                p.produtoId !== produtoEntrega &&
                (p.tpProduto === EnumTpProduto.ProdutoComSubItem ||
                    p.tpProduto === EnumTpProduto.Produto ||
                    p.tpProduto === EnumTpProduto.Combo ||
                    p.tpProduto === EnumTpProduto.Medicamento)
        );

        return produtosAgrupados.map((prodAgrupado) => {
            const prodAdicional = produtosVendaAdicionais.filter(
                (adicional) =>
                    adicional.idGroup === prodAgrupado.id &&
                    adicional.tpProduto !== EnumTpProduto.Combo &&
                    adicional.tpProduto !== EnumTpProduto.ProdutoComSubItem &&
                    adicional.tpProduto !== EnumTpProduto.Produto &&
                    adicional.tpProduto !== EnumTpProduto.Medicamento
            );
            if (prodAdicional.length > 0) {
                return {
                    ...prodAgrupado,
                    adicionais: prodAdicional,
                };
            }

            return prodAgrupado;
        });
    };

    const isDelivery = pedidoDelivery && !mesaId

    const solicitarCliente = useMemo(() => {
        return getConfigByCod(EnumConfigEmpresa.soliClientesPorModeloTrabalho)?.valor || ''
    }, [getConfigByCod])

    const soliClientesPorModeloTrabalho = useMemo(() => {
        return Number(solicitarCliente)
    }, [solicitarCliente])

    const handleClickProximo = useCallback(async () => {
        const pessoa = usePessoaUsuarioStore.getState().pessoa
        const { enderecoDelivery, tipoDelivery, setEnderecoDelivery } = useDadosDeliveryStore.getState()
        if (isDelivery) {
            if (pessoa) {
                setCliente(pessoa)
                if (tipoDelivery === undefined) {
                    onClickProximaFase(nextOrBack, EnumFasesSacola.InformarEndereco)
                    return
                }
                if (tipoDelivery === EnumOpcoesDelivery.Entrega) {
                    if (!enderecoDelivery?.id || enderecoDelivery?.id === guidEmpty() || enderecoDelivery?.pessoaId !== pessoa.id) {
                        setEnderecoDelivery(undefined)
                        onClickProximaFase(nextOrBack, EnumFasesSacola.InformarEndereco)
                        return
                    }

                    await addOuAttProdutoEntrega()
                } else {
                    removerItemEntregaSacola()
                }
                onClickProximaFase(nextOrBack, EnumFasesSacola.FormaPagamento)
                return
            }
        }
        if ((soliClientesPorModeloTrabalho === 0 || cardapioDados?.configuracoes.tipoUsoCardapio === 1) && !isDelivery) {
            handlePedidoFluxo(nextOrBack)
            return
        } if (cliente !== null) {
            onClickProximaFase(nextOrBack, EnumFasesSacola.InformarEndereco)
            return
        }
        onClickProximaFase(nextOrBack, EnumFasesSacola.IdentificarCliente)
    }, [isDelivery, soliClientesPorModeloTrabalho, cardapioDados?.configuracoes.tipoUsoCardapio, cliente, onClickProximaFase, setCliente, addOuAttProdutoEntrega, removerItemEntregaSacola, handlePedidoFluxo])

    const removerItem = useCallback(
        (id: string) => {

            removerSacola({ idProduto: id, empresaId: empresaId });
        },
        [empresaId, removerSacola],
    );


    const fluxoPedidoWhatsapp = useCallback(() => {
        if (
            dadosWhatsapp === undefined ||
            (tipoDelivery === EnumOpcoesDelivery.Entrega &&
                cardapioDados?.configuracoes?.permiteEntrega === false) ||
            (tipoDelivery === EnumOpcoesDelivery.Retirada &&
                cardapioDados?.configuracoes?.permiteRetirada === false)
        ) {
            onClickProximaFase(nextOrBack, EnumFasesSacola.InformarEndereco);
        } else {
            fazerPedidoWhatsApp()
        }
    }, [dadosWhatsapp, tipoDelivery, cardapioDados?.configuracoes?.permiteEntrega, cardapioDados?.configuracoes?.permiteRetirada, onClickProximaFase, fazerPedidoWhatsApp])

    const getMesaDados = useMemo(() => {
        const mesaStorage = getRegistro(CardapioStorageKeys.MesaAtual, false);
        const mesaZustand = useMesaStore.getState().mesa
        return isEmpty(mesaStorage) ? mesaZustand : mesaStorage;
    }, [getRegistro]);

    const temClientePedido = useCallback(async () => {
        if (!mesaId) {
            return false
        }
        const cliente = pedidoAtual?.cliente
        const clientePadraoWrapper = await getClientePadraoWrapper()
        const clientePadrao = clientePadraoWrapper
        if (!pedidoAtual) {
            return false
        }

        return cliente?.razaoSocial !== clientePadrao?.nome || cliente?.cpfCnpj !== clientePadrao?.cpfcnpj
    }, [getClientePadraoWrapper, mesaId, pedidoAtual])

    // const description = useMemo(() => {
    //     const clientePedido = pedidoAtual?.cliente
    //     return (
    //         <div>
    //             <>
    //                 <Typography>
    //                     Verificamos que já foi identificado um cliente para este pedido. Deseja continuar com o mesmo cliente?
    //                 </Typography>
    //                 <Box mt={2} />
    //                 {clientePedido?.razaoSocial && (
    //                     <Typography variant='body1'>
    //                         Nome: {clientePedido?.razaoSocial ?? ''}
    //                     </Typography>
    //                 )}
    //             </>
    //         </div >
    //     )
    // }, [pedidoAtual?.cliente])

    const contatos = useMemo(() => {
        let contatosArray: ContatoModel[] = []
        const telefone = new ContatoModel(
            guidEmpty(),
            guidEmpty(),
            EnumTipoContato.TELEFONE,
            pedidoAtual?.cliente?.telefone.replace(/\D/g, "")
        )
        const email = new ContatoModel(
            guidEmpty(),
            guidEmpty(),
            EnumTipoContato.EMAIL,
            pedidoAtual?.cliente?.email
        )
        if (!isEmpty(pedidoAtual?.cliente.telefone)) {
            contatosArray.push(telefone)
        }
        if (!isEmpty(pedidoAtual?.cliente.email)) {
            contatosArray.push(email)
        }

        return contatosArray
    }, [pedidoAtual?.cliente?.email, pedidoAtual?.cliente?.telefone])

    const handleFinalizar = useCallback(async () => {
        const clientePedido = await temClientePedido()
        if (clientePedido) {
            setCliente({
                ...new PessoaModel(),
                contatos: contatos,
                nome: pedidoAtual?.cliente.razaoSocial ?? '',
                id: pedidoAtual?.cliente.referenceId ?? '',
                cpfcnpj: pedidoAtual?.cliente.cpfCnpj ?? '',
                dtNasc: pedidoAtual?.cliente.dataNascimento ?? '',
            })
            handlePedidoFluxo(nextOrBack)
            return
        }
        handleClickProximo()
    }, [contatos, handleClickProximo, handlePedidoFluxo, pedidoAtual?.cliente.cpfCnpj, pedidoAtual?.cliente.dataNascimento, pedidoAtual?.cliente.razaoSocial, pedidoAtual?.cliente.referenceId, setCliente, temClientePedido])

    const faseAtual = faseSacola === EnumFasesSacola.Sacola
    const isFluxoPedido = clienteEstaNaLoja() || pedidoDelivery

    useEffect(() => {
        if (faseAtual) {
            setCodComanda(null)
        }
    }, [faseAtual, setCodComanda])

    return (
        <Slide appear={false} mountOnEnter unmountOnExit direction={nextOrBack.current === 1 ? 'left' : 'right'} in={faseAtual}>
            <Box height={"100%"} width={"100%"} className={classes.boxContainer}>
                {(carregando || carregandoEfetuarNovaVenda) && <CircularLoading tipo="FULLSIZED" titulo="Aguarde alguns instantes..." />}
                <FasesHeader titulo="CARRINHO" icon={CarrinhoIcon} voltar={quandoFechado} isSacola handleLimparSacola={() => {
                    esvaziarSacola({
                        empresaId
                    })
                    quandoFechado()
                }} />
                <Box className={classes.content}>
                    {(itens || []).length > 0 ? (
                        <>
                            <div className={classes.scrollable}>
                                {(!isEmpty(mesaId) &&
                                    <Typography color="textPrimary" className={classes.mesa}>
                                        Mesa: {getMesaDados?.codigo} {!isEmpty(codComanda) ? `| Comanda: ${codComanda}` : ''}
                                    </Typography>)}
                                {agruparProdutos().map((item) => {
                                    return (
                                        <ItemSacolaCard
                                            key={item.id}
                                            item={item}
                                            quandoEditar={editarItem}
                                            quandoRemover={removerItem}
                                        />
                                    );
                                })}
                                <Box width="100%" display="flex" justifyContent="center">
                                    <Button variant="text" size="large" onClick={() => quandoFechado()}>
                                        Adicionar novos itens
                                    </Button>
                                </Box>
                            </div>

                            <div className={classes.footer}>
                                {!mesaId && (
                                    <OpcoesDelivery
                                        empresa={cardapioDados?.empresa!}
                                        quandoClicar={() => {
                                            foiAbertoSacola.current = true
                                            onClickProximaFase(nextOrBack, EnumFasesSacola.InformarEndereco)
                                        }}
                                        permiteEntrega={cardapioDados?.configuracoes.permiteEntrega}
                                        permiteRetirada={cardapioDados?.configuracoes.permiteRetirada}
                                    />
                                )}
                                <PedidoValores />
                                <Grid container justify="center" className={classes.grdBtns}>
                                    <Button
                                        variant="contained"
                                        size="large"
                                        className={classNames(!isFluxoPedido && classes.buttonPedir, classes.btnFooter)}
                                        startIcon={isFluxoPedido ? <OkIcon tipo="BUTTON_PRIMARY" /> : <WhatsAppIcon />}
                                        onClick={
                                            isFluxoPedido
                                                ? handleFinalizar
                                                : fluxoPedidoWhatsapp
                                        }

                                    >
                                        {isFluxoPedido ? "Finalizar pedido" : "Fazer pedido no WhatsApp"}
                                    </Button>
                                </Grid>
                                <Grid container justify="center" className={classes.grdBtns}>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        className={classNames(!isFluxoPedido && classes.buttonPedir, classes.btnFooter)}
                                        onClick={quandoFechado}

                                    >
                                        <VoltarIcon tipo="BUTTON" />
                                        Continuar comprando
                                    </Button>
                                </Grid>
                            </div >
                        </>
                    ) : (
                        <div className={classes.sacolaVazia}>
                            <img
                                src={sacolaVazia}
                                className={classes.imgSacolaVazia}
                                alt="sacola vazia"
                                style={{ filter: calcularCorSacola() }}
                            ></img>
                            <Typography variant="h4" color="textPrimary" className={classes.weight}>
                                A sacola está vazia!
                            </Typography>
                        </div>
                    )}
                </Box>
            </Box>
        </Slide >
    )
}